import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// https://appdividend.com/2018/05/08/vuex-axios-get-request-tutorial-with-example/#Step_5_Create_an_action

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
let API_HOST = window.location.protocol + '//' + window.location.host + '/api/'
let API2_HOST = window.location.protocol + '//' + window.location.host + '/api2/'
if (debug) {
  API_HOST = window.location.protocol + '//localhost:19351/api/'
  API2_HOST = window.location.protocol + '//localhost:19352/api2/'
}

export default new Vuex.Store({
  state: {
    noticeObject: {},
    account: {},
    block: {},
    blocksOverview: [],
    chainStatus: {
      blockHeight: 0,
      transactionsPerDay: 0,
      transactionsPerHour: 0,
      transactionsPerMin: 10,
      latestTransactions: [],
      txSamples: [],
      peers: 0,
      frontiers: 0,
      lastBlockTime: 0
    },
    tx: {},
    receipt: {},
    extra: {},
    txJson: '',
    receiptJson: '',
    contract: {},
    loading: false,
    socket: {
      isConnected: false,
      message: '',
      reconnectError: false
    }
  },
  getters: {
    blocksOverview: state => state.blocksOverview,
    chainStatus: state => state.chainStatus,
    account: state => state.account,
    tx: state => state.tx,
    receipt: state => state.receipt,
    extra: state => state.extra,
    contract: state => state.contract
  },
  actions: {
    setLoading ({ commit }, isLoading) {
      commit('SET_LOADING', isLoading)
    },
    loadAccount ({ commit }, address) {
      axios
        .get(API_HOST + 'address/' + address)
        .then(resp => {
          commit('SET_ACCOUNT', resp.data)
        })
        .catch((e) => {
          commit('SET_ACCOUNT')
        })
    },
    loadBlock ({ commit }, hash) {
      axios
        .get(API_HOST + 'block/' + hash)
        .then(resp => {
          commit('SET_BLOCK', resp.data)
        })
        .catch((e) => {
          commit('SET_BLOCK')
        })
    },
    loadBlocksOverview ({ commit }) {
      axios
        .get(API_HOST + 'blocks/overview')
        .then(resp => {
          commit('SET_BLOCKS_OVERVIEW', resp.data)
        })
        .catch((e) => {
          commit('SET_BLOCKS_OVERVIEW')
        })
    },
    loadTransaction ({ commit }, hash) {
      axios
        .get(API2_HOST + 'tx/' + hash)
        .then(resp => {
          commit('SET_TRANSACTION', resp.data)
        })
        .catch((e) => {
          commit('SET_TRANSACTION')
        })
    },
    loadContract ({ commit }, hash) {
      axios
        .get(API2_HOST + 'contract/' + hash)
        .then(resp => {
          commit('SET_CONTRACT', resp.data)
        })
        .catch((e) => {
          commit('SET_CONTRACT')
        })
    }
  },
  mutations: {
    SET_LOADING (state, isLoading) {
      state.loading = isLoading
    },
    SET_ACCOUNT (state, account) {
      state.account = account || {}
    },
    SET_BLOCK (state, block) {
      state.block = block || {}
    },
    SET_BLOCKS_OVERVIEW (state, data) {
      state.blocksOverview = data || []
    },
    SET_TRANSACTION (state, data) {
      state.tx = data || {}
      // receipt
      if (data && data.receipt) {
        state.receipt = JSON.parse(data.receipt)
      } else {
        state.receipt = {}
      }

      const t = JSON.parse(JSON.stringify(state.tx))
      delete t.what
      delete t.extra
      delete t.receipt
      state.txJson = JSON.stringify(t, undefined, 2)
      state.receiptJson = JSON.stringify(state.receipt, undefined, 2)

      // extra
      if (data && data.extra) {
        state.extra = data.extra
        if (data.extra.arguments) {
          state.extra.arguments = JSON.parse(data.extra.arguments)
        } else {
          state.extra.arguments = {}
        }
      } else {
        state.extra = {}
      }
    },
    SET_CONTRACT (state, data) {
      state.contract = {}
      if (data && data.name) {
        state.contract.name = data.name
      }
      if (data && data.events && data.events.length > 0) {
        state.contract.events = []
        for (let i in data.events) {
          const event = data.events[i]
          state.contract.events[i] = event
          if (event.input && event.input.startsWith('{')) {
            state.contract.events[i].input = JSON.parse(event.input)
          }
        }
      }
    },
    // Websocket
    SOCKET_ONOPEN (state, event) {
      state.socket.isConnected = true
    },
    SOCKET_ONCLOSE (state, event) {
      state.socket.isConnected = false
    },
    SOCKET_ONERROR (state, event) {
      console.error(state, event)
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE (state, message) {
      state.socket.message = message
      try {
        const data = JSON.parse(message.data)
        if (data.what === 'chain-status' && data.data) {
          const status = data.data
          state.chainStatus.blockHeight = status && status.block_height ? status.block_height : 0
          state.chainStatus.transactionsPerDay = status && status.transaction_per_day ? status.transaction_per_day : 0
          state.chainStatus.transactionsPerHour = status && status.transaction_per_hour ? status.transaction_per_hour : 0
          state.chainStatus.transactionsPerMin = status && status.transaction_per_min ? status.transaction_per_min : 0
          state.chainStatus.latestTransactions = status && status.transactions ? status.transactions : []
          state.chainStatus.txSamples = status && status.tx_samples ? status.tx_samples : []
          state.chainStatus.peers = status && status.peers ? status.peers : 0
          state.chainStatus.frontiers = status && status.frontiers ? status.frontiers : 0
          state.chainStatus.lastBlockTime = status && status.last_block_time ? status.last_block_time : 0
        }
      } catch (e) {
      }
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT (state, count) {
      console.info(state, count)
    },
    SOCKET_RECONNECT_ERROR (state) {
      state.socket.reconnectError = true
    }
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js